<template>
  <fieldset
    :key="thingThatICanIncrementToForceAnImmediateRedraw"
    :class="{
      'starability-basic': true,
      [`starability-basic--${size}`]: size,
    }"
  >
    <legend>Note :</legend>
    <input
      :id="`rate5-${_uid}`"
      type="radio"
      :class="{ checked: rating === 5 }"
      name="rating"
      value="5"
      @click="onClick"
    />
    <label
      :for="`rate5-${_uid}`"
      title="EXCELLENT - J'envisage de choisir ce design."
      aria-label="EXCELLENT - J'envisage de choisir ce design."
      data-test-rating="excellent"
    >
      5 étoiles
    </label>
    <input
      :id="`rate4-${_uid}`"
      type="radio"
      :class="{ checked: rating === 4 }"
      name="rating"
      value="4"
      @click="onClick"
    />
    <label
      :for="`rate4-${_uid}`"
      title="TRÈS BIEN - Présentation de bonne qualité qui a besoin d'un peu de travail"
      aria-label="TRÈS BIEN - Présentation de bonne qualité qui a besoin d'un peu de travail"
      data-test-rating="very-good"
    >
      4 étoiles
    </label>
    <input
      :id="`rate3-${_uid}`"
      type="radio"
      :class="{ checked: rating === 3 }"
      name="rating"
      value="3"
      @click="onClick"
    />
    <label
      :for="`rate3-${_uid}`"
      title="BIEN - Bon début mais j'aimerais quelques modifications"
      aria-label="BIEN - Bon début mais j'aimerais quelques modifications"
      data-test-rating="good"
    >
      3 étoiles
    </label>
    <input
      :id="`rate2-${_uid}`"
      type="radio"
      :class="{ checked: rating === 2 }"
      name="rating"
      value="2"
      @click="onClick"
    />
    <label
      :for="`rate2-${_uid}`"
      title="PAUVRE - Je n'aime pas ce design, mais j'aimerais que ce designer en propose un autre"
      aria-label="PAUVRE - Je n'aime pas ce design, mais j'aimerais que ce designer en propose un autre"
      data-test-rating="poor"
    >
      2 étoiles
    </label>
    <input
      :id="`rate1-${_uid}`"
      type="radio"
      :class="{ checked: rating === 1 }"
      name="rating"
      value="1"
      @click="onClick"
    />
    <label
      :for="`rate1-${_uid}`"
      title="TRES FAIBLE - Le design ne suit pas le brief ou est de très mauvaise qualité"
      aria-label="TRES FAIBLE - Le design ne suit pas le brief ou est de très mauvaise qualité"
      data-test-rating="very-poor"
    >
      1 étoile
    </label>
  </fieldset>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: undefined,
    },
    rating: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      thingThatICanIncrementToForceAnImmediateRedraw: 0,
    };
  },
  methods: {
    onClick(event) {
      let rating = parseInt(event.target.value, 10);
      if (this.rating === rating) {
        rating = 0;
      }
      this.$emit('click', rating);
      if (rating === 0) {
        this.thingThatICanIncrementToForceAnImmediateRedraw += 1;
      }
    },
  },
};
</script>
